import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtils } from '../utils/number.utils';
import {ObjectUtils} from '../utils/object.utils';
import {CommonConstant} from '../app.constants';
import {Currency} from '../../models/Billing/currency';

@Pipe({
  name: 'thousandNumberSuffix'
})
export class ThousandNumberSuffixPipe implements PipeTransform {
  transform(value: number, decimals: number = 0): string {
    return NumberUtils.normalizeNumberToString(value, decimals);
  }
}

@Pipe({
  name: 'percentNumberSuffix'
})
export class PercentNumberSuffixPipe implements PipeTransform {
  transform(value: number, decimals: number = 0): string {
    const  multiplier = Math.pow(10, decimals || 0);
    const roundedValue =  Math.round(value * multiplier) / multiplier;
    return roundedValue + '%';
  }
}


@Pipe({
  name: 'formatNumberToString'
})
/**
 * a pipe used to convert number to string as formatter (XXX,XXX,XXX,XXX)
 * Example:
 * 11650 should be formatted 11,650
 * 120 should be formatted 120
 * 1000000 should be formatted 1,000,000
 * @param value
 * @returns {string}
 */
export class FormatNumberToStringPipe implements PipeTransform {
  transform(value: number, hasMore?: boolean): string {
    const formatedValue = NumberUtils.formatNumberToString(value);

    if (hasMore) {
      return formatedValue + '+';
    } else {
      return formatedValue;
    }
  }
}


@Pipe({
  name: 'currencyFormatting'
})
export class CurrencyPipe implements PipeTransform {
  transform(value: number, currency: number): string {
    return ObjectUtils.currencyFormat(value, currency);
  }
}

@Pipe({
  name: 'currencySymbolismFormatting'
})
export class CurrencySymbolismPipe implements PipeTransform {
  transform(value: number, fractionDigits: number, currency: Currency): string {
    return value ? ObjectUtils.formatNumberToCurrencyBySymbolic(value, currency, fractionDigits) : '-';
  }
}


@Pipe({
  name: 'fileSizeFormatting'
})
export class FileSizePipe implements PipeTransform {
  transform(fileSize: number): string {
    const kbValue = fileSize / CommonConstant.KB_UNIT;

    if (kbValue > CommonConstant.KB_UNIT) {
      return Math.round((kbValue / CommonConstant.KB_UNIT)) + ' mb';
    } else {
      return Math.round(kbValue) + ' kb';
    }
  }
}

@Pipe({
  name: 'formatInteractionNumber'
})
export class FormatInteractionNumberPipe implements PipeTransform {
  transform(value: number, authorized: boolean, story: boolean, decimals: number = 0) {
    return NumberUtils.formatInteractionNumber(value, authorized, story, decimals);
  }
}

@Pipe({
  name: 'formatInteractionPercentage'
})
export class FormatInteractionPercentagePipe implements PipeTransform {
  transform(value: number, authorized: boolean, story: boolean, decimals: number = 0): string {
    if (story && (!authorized || value === 0)) {
      return '-';
    } else {
      const  multiplier = Math.pow(10, decimals || 0);
      const roundedValue =  Math.round(value * multiplier) / multiplier;
      return roundedValue === 0 && value > 0 ? '<1%' : roundedValue + '%';
    }
  }
}

@Pipe({
  name: 'userUsagePipe'
})
export class UserUsagePipe implements PipeTransform {
  transform(value: number | string): number | string {
    return value ? value : '-';
  }
}

@Pipe({
  name: 'impactFilterSuffix'
})
export class ImpactFilterSuffixPipe implements PipeTransform {
  transform(value: number, hasMore: boolean = false): string {
    const  multiplier = Math.pow(10, 0);
    const roundedValue =  Math.round(value * multiplier) / multiplier;
    return hasMore ? `${roundedValue}%+` : `${roundedValue}%`;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/custom-number-format.pipe.ts